import { Autocomplete, Backdrop, Box, Button, CircularProgress, Fade, Grid, IconButton, Modal, TextField, Typography } from '@mui/material';
import Markdown from 'react-markdown';
import CloseIcon from '@mui/icons-material/Close';
import { useGetCodeTranslationQuery } from '../../redux/apis/getCodeTranslation.api';
import { useMemo, useState } from 'react';
import { extendErrFormInitialData, extendFormInitialData, validityExtendOptions } from '../../pages/NewFigma/eWayBill/data';
import { axiosInstanceForLambda } from '../../library/Axios';
import API_ENDPOINTS from '../../apiEndpoints';
import { showSuccessSnackbar, showWarningSnackbar } from '../snackBar/snakbar';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { einvAuth, einvAuthData, einvId, einvPreview } from '../../redux/reducers/eInvReducer';
const style = {
  position: 'absolute',
  right: '10%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  display: 'flex',
  flexDirection: 'column',

  padding: '0px',
  height: '50%',
  width: '40%',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%,-50% )',
};

const EWayExtend = ({
  open,
  setOpen,
  title,
  extendData,
  // setBackdropOpen,
  setData,
}) => {
  const [formData, setFormData] = useState(extendFormInitialData);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [errFormData, setErrFormData] = useState(extendErrFormInitialData);
  console.log(formData, 'formData');
  const navigate = useNavigate();
  const { data: stateList, isSuccess: stateListSuc } = useGetCodeTranslationQuery({ codetype: 'IndiaState' });
  let statesLists = useMemo(() => {
    if (!stateList) return [];
    return stateList.map((element) => {
      return {
        label: element.codetext,
        id: `${element.codetext}District`,
        statecode: element.statecode,
      };
    });
  }, [stateList]);
  console.log(formData, 'formData');

  const emptyCheckInput = (input, name, val) => {
    console.log(input, 'input');
    console.log(name, 'name');
    console.log(val, 'val');
    setFormData({
      ...formData,
      [name]: val || val?.id,
    });
    if (!val) {
      setErrFormData((prev) => ({
        ...prev,
        [name]: 'Required Field',
      }));
    } else {
      setErrFormData((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  const handleChange = (name, val) => {
    console.log(val, 'jjj');
    emptyCheckInput(formData[name]?.id ? formData[name]?.id : formData[name], name, val);
    // if (val !== "" || val?.id !== "") {
    //   setFormData({
    //     ...formData,
    //     [name]: val,
    //   });
    //   setErrFormData((prev) => ({
    //     ...prev,
    //     [name]: "",
    //   }));
    // } else {
    // }
  };
  console.log(Number(formData.pincode), 'Number(formData.pincode)');
  let prevData = useSelector((state) => state.eInvReducer.data);
  const dispatch = useDispatch();
  const saveChanges = async () => {
    console.log(formData, 'formData');
    // emptyCheckInput(formData.city, "city");
    // emptyCheckInput(formData.distance, "distance");
    // emptyCheckInput(formData.district, "district");
    // emptyCheckInput(formData.reasoncode, "reasoncode");
    // emptyCheckInput(formData.remarks, "remarks");
    if (
      extendData.ewbNo &&
      extendData.vehicleNo &&
      formData.city &&
      formData.district.statecode &&
      formData.distance &&
      formData.reasoncode.id &&
      formData.pincode &&
      formData.remarks
    ) {
      setBackdropOpen(true);
      const payload = {
        action: 'EXTENDVALIDITY',
        // credentials: {
        //   userName: "AL001",
        //   password: "Alankit@123",
        // Gstin: "07AGAPA5363L002",
        // userName: "Matrix2050",
        // password: "Matrix@2050",
        // Gstin: "33AAHCS2907G1ZK",
        // },
        data: {
          ewbNo: extendData.ewbNo,
          vehicleNo: extendData.vehicleNo,
          fromPlace: formData.city,
          fromState: formData.district.statecode,
          remainingDistance: Number(formData.distance),
          // transDocNo: "1234",
          // transDocDate: "09/04/2025",
          transMode: '5',
          extnRsnCode: Number(formData.reasoncode.id),
          extnRemarks: formData.remarks,
          fromPincode: Number(formData.pincode.replace(/\s+/g, '')),
          consignmentStatus: 'T',
          transitType: 'R',
          addressLine1: formData.city,
          addressLine2: formData.city,
          addressLine3: formData.city,
        },
        ...(Object.keys(prevData).length > 0 ? { credentials: prevData } : null),
      };
      if (
        formData.city !== '' &&
        formData.distance !== '' &&
        formData.district.id !== '' &&
        formData.reasoncode.id !== '' &&
        formData.remarks !== '' &&
        formData.pincode !== ''
      ) {
        try {
          const res = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_EWAYBILL_URL, payload);
          if (res.status === 200) {
            showSuccessSnackbar('E-way Bill validity extended successfully');
            setData((prev) =>
              prev.map((item) => {
                console.log(item, 'itemmmmmmm');
                if (item?.ewaybillno === extendData?.ewbNo) {
                  return {
                    ...item,
                    validupto: dayjs(res?.data?.data?.validUpto, 'D/MM/YYYY hh:mm:ss A').unix(),
                    status: 'Active',
                    // value: {
                    //   ...item.value, // Preserve other properties inside value
                    //   validUpto: res?.data?.data?.validUpto,
                    // },
                  };
                }
                return item;
              })
            );
          }
          setFormData(extendFormInitialData);
          setErrFormData(extendErrFormInitialData);
          setOpen(false);
          // if (formik.values.supply === "O") {
          //     navigate("/salesInvoiceReport");
          //   } else {
          //     navigate("/allpurchaseandexpense");
          //   }
          // }
        } catch (error) {
          console.log(error, 'error');
          const formatted =
            error.response.data.details.length === 0
              ? ''
              : error.response.data.details.length === 1
              ? error.response.data.details[0].errorDesc + '.'
              : error.response.data.details
                  .map((item, index) => {
                    if (index === error.response.data.details.length - 1) return item.errorDesc + '.';
                    return item.errorDesc + ',';
                  })
                  .join(' ');
          const errorMessage = formatted ? formatted : error.response.statusText;
          showWarningSnackbar(errorMessage);
        } finally {
          setBackdropOpen(false);
          dispatch(einvAuthData({}));
          dispatch(einvAuth(false));
          dispatch(einvPreview({ preview: false, id: 0 }));
          dispatch(einvId(false));
        }
      }
    } else {
      showWarningSnackbar('Please fill all fields');
    }
  };
  console.log(statesLists, 'statesLists');
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      onClose={() => setOpen(false)}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              backgroundColor: 'primary.main',

              display: 'flex',
              fontSize: '16px',
              fontWeight: 'bold',
              color: 'white',

              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ marginLeft: '10px', marginTop: '5px' }}>Extend Validity</Box>
            <Box sx={{ marginTop: '-2px' }}>
              <IconButton aria-label="delete" onClick={() => setOpen(false)}>
                <CloseIcon sx={{ color: 'white' }} />
              </IconButton>
            </Box>
          </Box>
          <Grid container sx={{ padding: '30px' }} gap={1}>
            <Grid item xs={12}>
              <Typography variant="h2" sx={{ color: 'black', fontWeight: 'bold' }}>
                {title}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={6}>
              <Autocomplete
                id="district"
                options={statesLists}
                value={statesLists.find((option) => formData.district?.id === option.id) || null}
                getOptionLabel={(option) => {
                  return option.label || '';
                }}
                onChange={(_, newValue) => handleChange('district', newValue)}
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select State"
                    required={true}
                    sx={{
                      '.MuiFormLabel-asterisk': {
                        color: 'danger.main',
                        fontSize: '20px',
                        fontWeight: 'bold',
                      },
                    }}
                    //   inputRef={ref}
                    //   required={formik.errors[name] && !formik.values[name]}
                    //   error={formik.touched[name] && formik.errors[name]}
                  />
                )}
              />
              {errFormData.district !== '' ? (
                <Typography variant="body1" className="error" style={{ fontSize: '13px' }}>
                  {errFormData.district}
                </Typography>
              ) : (
                <p style={{ padding: '8px' }}></p>
              )}
            </Grid>
            <Grid item xs={12} lg={5.5}>
              <TextField
                size="small"
                name="city"
                required={true}
                label="City"
                value={formData.city}
                sx={{
                  '.MuiFormLabel-asterisk': {
                    color: 'danger.main',
                    fontSize: '20px',
                    fontWeight: 'bold',
                  },
                }}
                onChange={(e) => handleChange('city', e.target.value)}
                fullWidth
                //   error={formik.touched[name] && formik.errors[name]}
              />
              {errFormData.city !== '' ? (
                <Typography variant="p" className="error" style={{ fontSize: '13px', padding: '0px' }}>
                  {errFormData.city}
                </Typography>
              ) : (
                <p style={{ padding: '8px' }}></p>
              )}
            </Grid>
            <Grid item xs={12} lg={3}>
              <TextField
                size="small"
                name="pincode"
                required={true}
                label="Pincode"
                value={formData.pincode}
                sx={{
                  '.MuiFormLabel-asterisk': {
                    color: 'danger.main',
                    fontSize: '20px',
                    fontWeight: 'bold',
                  },
                }}
                onChange={(e) => handleChange('pincode', e.target.value)}
                fullWidth
                //   error={formik.touched[name] && formik.errors[name]}
              />
              {errFormData.pincode !== '' ? (
                <Typography variant="p" className="error" style={{ fontSize: '13px', padding: '0px' }}>
                  {errFormData.pincode}
                </Typography>
              ) : (
                <p style={{ padding: '8px' }}></p>
              )}
            </Grid>
            <Grid item xs={12} lg={8.5}>
              <Autocomplete
                name="reasoncode"
                value={validityExtendOptions.find((option) => option.id === formData.reasoncode?.id) || null}
                options={validityExtendOptions}
                getOptionLabel={(option) => {
                  console.log(option, 'option');
                  return option.label || '';
                }}
                onChange={(_, newValue) => handleChange('reasoncode', newValue)}
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select a Reason"
                    required={true}
                    sx={{
                      '.MuiFormLabel-asterisk': {
                        color: 'danger.main',
                        fontSize: '20px',
                        fontWeight: 'bold',
                      },
                    }}
                    //   inputRef={ref}
                    //   required={formik.errors[name] && !formik.values[name]}
                    //   error={formik.touched[name] && formik.errors[name]}
                  />
                )}
              />
              {errFormData.reasoncode !== '' ? (
                <Typography variant="p" className="error" style={{ fontSize: '13px' }}>
                  {errFormData.reasoncode}
                </Typography>
              ) : (
                <p style={{ padding: '8px' }}></p>
              )}
            </Grid>
            <Grid item xs={12} lg={3}>
              <TextField
                size="small"
                name="distance"
                required={true}
                label="Distance"
                sx={{
                  '.MuiFormLabel-asterisk': {
                    color: 'danger.main',
                    fontSize: '20px',
                    fontWeight: 'bold',
                  },
                }}
                value={formData.distance}
                onChange={(e) => handleChange('distance', e.target.value)}
                fullWidth
                //   error={formik.touched[name] && formik.errors[name]}
              />
              {errFormData.distance !== '' ? (
                <Typography variant="p" className="error" style={{ fontSize: '13px' }}>
                  {errFormData.distance}
                </Typography>
              ) : (
                <p style={{ padding: '8px' }}></p>
              )}
            </Grid>

            <Grid item xs={12} lg={8.5}>
              <TextField
                size="small"
                name="remarks"
                required={true}
                value={formData.remarks}
                label="Remarks"
                sx={{
                  '.MuiFormLabel-asterisk': {
                    color: 'danger.main',
                    fontSize: '20px',
                    fontWeight: 'bold',
                  },
                }}
                //   value={formik.values[name] || value}
                onChange={(e) => handleChange('remarks', e.target.value)}
                fullWidth
                //   error={formik.touched[name] && formik.errors[name]}
              />
              {errFormData.remarks !== '' ? (
                <Typography variant="p" className="error" style={{ fontSize: '13px' }}>
                  {errFormData.remarks}
                </Typography>
              ) : (
                <p style={{ padding: '8px' }}></p>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} lg={12} sx={{ padding: '0px 20px' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: { xs: 'column', sm: 'row' },
              }}
            >
              <Button onClick={saveChanges} variant="contained" sx={{ flex: 1, margin: '0px 10px', fontSize: '12px' }}>
                Save
              </Button>
              <Button onClick={() => setOpen(false)} variant="outlined" sx={{ flex: 1, margin: '0px 20px', fontSize: '12px' }}>
                Cancel
              </Button>
            </Box>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
              <CircularProgress color="inherit" />
            </Backdrop>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};

export default EWayExtend;
